<template>
  <div class="row p-3">
    <div class="col-12">
      <h1>Get the CorSync Mobile App</h1>

      <br>
      <br>

      <p><a href="https://play.google.com/store/apps/details?id=com.nuvita.cardiopro.android" id="android-link" target="_blank">
        <img width="270" src="/media/GooglePlayBadge.png" alt="Get it on Google Play"/>
      </a></p>

      <br>

      <p><a href="https://apps.apple.com/us/app/corsync/id6443709110" id="ios-link" target="_blank">
        <img width="270" src="/media/AppleAppStoreBadge.svg" alt="Apple App Store"/>
      </a></p>

      <br>
    </div>
  </div>
</template>

<script>
  export default {
    mounted() {
      var os = this.getMobileOperatingSystem();
      var androidStoreLink = this.androidStoreLink;
      var iOSStoreLink = this.iOSStoreLink;
      document.getElementById("android-link").href = androidStoreLink;
      document.getElementById("ios-link").href = iOSStoreLink;

      if (os === "Android") {
        window.location.href = androidStoreLink;
      } else if (os === "iOS") {
        window.location.href = iOSStoreLink;
      }
    },
    computed: {
      androidStoreLink() {
        const params = this.queryParams();
        if (params === null || params === '') {
          return "https://play.google.com/store/apps/details?id=com.nuvita.cardiopro.android";
        } else {
          return "https://play.google.com/store/apps/details?id=com.nuvita.cardiopro.android&referrer=" + params;
        }
      },
      iOSStoreLink() {
        const params = this.queryParams();
        if (params === null || params === '') {
          return "https://apps.apple.com/us/app/corsync/id6443709110";
        } else {
          return "https://apps.apple.com/us/app/corsync/id6443709110&referrer=" + params;
        }
      }
    },
    methods: {
      getMobileOperatingSystem: function() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
          return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
        }

        return "unknown";
      },
      queryParams: function () {
        var urlParams = new URLSearchParams(window.location.search);
        return encodeURIComponent(urlParams.toString());
      }
    }
  }
</script>
